import AuthService from '../../services/AuthService'
import UsersService from '../../services/UsersService'
import router from '../../router'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'

export const namespaced = true

const initialState = {
  user: null,
  signUpUser: null,
  signUpErrorStatus: false,
  emailAddressVerificationStatus: null,
  loginResetProcessStatus: null
}

export const state = {
  user: null,
  signUpUser: null,
  signUpErrorStatus: false,
  emailAddressVerificationStatus: null,
  loginResetProcessStatus: null
}

export const mutations = {
  //LOGOUT() {
  //localStorage.removeItem('apiCredentials')
  //router.push('/').catch(err => {})
  //},
  RESET_STORE(state) {
    Object.assign(state, initialState)
  },
  INIT_USER_SIGN_UP() {
    router.push('/signup').catch(err => {})
  },
  SIGN_UP_USER(state, data) {
    state.signUpUser = data
  },
  SET_SIGNUP_ERROR_STATUS(state, data) {
    state.signUpErrorStatus = data
  },
  SET_EMAIL_ADDRESS_VERIFICATION_STATUS(state, data) {
    state.emailAddressVerificationStatus = data
  },
  SET_LOGIN_RESET_PROCESS_STATUS(state, data) {
    state.loginResetProcessStatus = data
  }
}

export const actions = {
  authenticateUser: async function(context, value) {
    try {
      context.commit('SET_LOADING_STATUS', 'loading', { root: true })
      let authResult = await AuthService.authUser(value)
      if (authResult.data.bf) {
        //localStorage.apiCredentials = authResult.data.token
        if (authResult.data.message) {
          let params = {
            title: authResult.data.message,
            persistent: false,
            okText: 'Ok'
          }
          await context.dispatch('DialogStore/open', params, { root: true })
        }
        let userProfileResponse = await UsersService.getUserProfile()
        await context.dispatch(
          'UserStore/setCurrentUser',
          userProfileResponse.data,
          { root: true }
        )
        await router.push('/projects')
      } else {
        throw new Error(`User has no privilege to log in.`)
      }
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }

    // .then(response => {
    //
    // })
    // .then(resp => {
    //   context.dispatch('UserStore/setCurrentUser', resp.data, { root: true })
    //   router.push('/').catch(err => {})
    // })
    // .catch(e => {
    //   AxiosErrorHandler.handler(e, context, router)
    // })
    //.finally(() => {
    //router.push('/').catch(err => {})
    //})
  },
  refreshUserProfile: async function(context) {
    try {
      let userProfileResp = await UsersService.getUserProfile()
      await context.dispatch('UserStore/setCurrentUser', userProfileResp.data, {
        root: true
      })
      //if (window.location.pathname !== '/reset-login') {
      //await router.push('/')
      //}
    } catch (e) {
      context.commit('RESET_STORE')
      //context.commit('LOGOUT')
      await context.dispatch('UserStore/logout', null, { root: true })
    }
  },
  // logout: async function(context) {
  //   context.commit('RESET_STORE')
  //   context.commit('LOGOUT')
  //   await context.dispatch('UserStore/resetUserSession', null, { root: true })
  //   //context.commit('resetState')
  // },
  signUpInit: function(context) {
    context.commit('INIT_USER_SIGN_UP')
    context.commit('SET_SIGNUP_ERROR_STATUS', false)
  },
  signUpUser: async function(context, value) {
    context.commit('SET_SIGNUP_ERROR_STATUS', false)
    return UsersService.signup(value)
      .then(resp => {
        context.commit('SIGN_UP_USER', resp.data)
        return UsersService.sendEmailAddressConfirmationLink(resp.data.email)
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
        context.commit('SET_SIGNUP_ERROR_STATUS', true)
      })
  },
  signUpComplete: async function(context) {
    context.commit('RESET_STORE')
    //context.commit('LOGOUT')
    context.dispatch('UserStore/logout', null, { root: true })
  },
  verifyEmailAddressCode: function(context, value) {
    if (!value) {
      AxiosErrorHandler.handler(
        {
          message:
            'Email address verification failed, please try again or resend verification code.'
        },
        context,
        router
      )
    } else {
      UsersService.verifyEmailAddressCode(value)
        .then(res => {
          context.commit('SET_EMAIL_ADDRESS_VERIFICATION_STATUS', res.data)
        })
        .catch(e => {
          AxiosErrorHandler.handler(e, context, router)
        })
    }
  },
  resetPasswordInit: function(context) {
    router.push('/reset-login').catch(err => {})
  },
  resetUserPassword: function(context, value) {
    UsersService.setUserPassword(value)
      .then(res => {
        context.commit('SET_LOGIN_RESET_PROCESS_STATUS', res.data)
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  sendLoginResetLink: async function(context, value) {
    if (!value) {
      return AxiosErrorHandler.handler(
        {
          message:
            'There was a problem with sending password reset link. Try again or call support.'
        },
        context,
        router
      )
    } else {
      return UsersService.sendLoginPasswordResetLink(value)
        .then(() => {
          context.commit('SET_LOGIN_RESET_PROCESS_STATUS', 'email-sent')
        })
        .catch(e => {
          context.commit('SET_LOGIN_RESET_PROCESS_STATUS', 'email-not-sent')
          AxiosErrorHandler.handler(e, context, router)
        })
    }
  },
  sendEmailAddressConfirmationLink: function(context, value) {
    if (!value) {
      AxiosErrorHandler.handler(
        {
          message:
            'There was a problem with sending email address confirmation link. Try again or call support.'
        },
        context,
        router
      )
    } else {
      UsersService.verifyEmailAddressCode(value)
        .then(res => {
          context.commit('SET_EMAIL_ADDRESS_VERIFICATION_STATUS', res.data)
        })
        .catch(e => {
          AxiosErrorHandler.handler(e, context, router)
        })
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  userBearerToken: state => {
    return state.bearerToken
  }
}
